import { Component }        from '@angular/core';
import {CacheNotificationDynamicAbstractClass} from "./dynamic-abstract-class";


@Component({
    selector: 'blank',
    template: ''
})
export class BlankComponent extends CacheNotificationDynamicAbstractClass {}
